import { req } from '../../@api/request';

export default class GameService {
  static create = async (
    title: string,
    description: string,
    bracketSize: number,
  ) => {
    const body = new URLSearchParams({
      title,
      description,
      bracket_size: String(bracketSize),
    });
    const result = await req.post('/balance-game', body);
    return result.data;
  };

  static list = async (page: number = 1, limit: number = 10) => {
    const result = await req.get(`/balance-game?page=${page}&limit=${limit}`);
    return result.data;
  };

  static update = async (
    gameId: number,
    title?: string,
    description?: string,
    bracketSize?: number,
  ) => {
    const body = new URLSearchParams();
    if (title) body.append('title', title);
    if (description) body.append('description', description);
    if (bracketSize) body.append('bracket_size', String(bracketSize));

    const result = await req.patch(`/balance-game/${gameId}`, body);
    return result.data;
  };

  static delete = async (gameId: number) => {
    const result = await req.delete(`/balance-game/${gameId}`);
    return result.data;
  };

  static addItem = async (gameId: number, iidx: number) => {
    const body = new URLSearchParams({ iidx: String(iidx) });
    const result = await req.post(`/balance-game/${gameId}/items`, body);
    return result.data;
  };

  static items = async (gameId: number) => {
    const result = await req.get(`/balance-game/${gameId}/items`);
    return result.data;
  };

  static deleteItem = async (gameId: number, itemId: number) => {
    const result = await req.delete(`/balance-game/${gameId}/items/${itemId}`);
    return result.data;
  };

  static startPlay = async (gameId: number) => {
    const result = await req.post(`/balance-game/${gameId}/play`, {});
    return result.data;
  };

  static getMatch = async (
    gameId: number,
    playId: number,
    round: number,
    playerId: string,
  ) => {
    const result = await req.get(
      `/balance-game/${gameId}/play/${playId}/${round}?playerId=${playerId}`,
    );
    return result.data;
  };

  static createMatch = async (
    gameId: number,
    playId: number,
    round: number,
    playerId: string,
  ) => {
    const result = await req.post(
      `/balance-game/${gameId}/play/${playId}/${round}?playerId=${playerId}`,
      {},
    );
    return result.data;
  };

  static selectWinner = async (
    gameId: number,
    playId: number,
    matchId: number,
    playerId: string,
    winnerItemId: number,
  ) => {
    const url = `/balance-game/${gameId}/play/${playId}/match/${matchId}?playerId=${playerId}`;

    const result = await req.customAxios.patch(
      url,
      JSON.stringify({ winner_item_id: winnerItemId }),
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    );

    return result.data;
  };
  static getRanking = async (gameId: number) => {
    const result = await req.get(`/balance-game/${gameId}/ranking`);
    return result.data;
  };
  static getWinningItems = async ({
    playerId,
    gameId = '',
    sort = 'AD',
    limit = 10,
    page = 1,
  }: {
    playerId?: string;
    gameId?: string;
    sort?: 'AA' | 'AD' | 'BA' | 'BD';
    limit?: number;
    page?: number;
  }) => {
    const queryParams = new URLSearchParams();

    if (playerId) queryParams.append('playerId', playerId);
    if (gameId) queryParams.append('gameId', gameId);
    if (sort) queryParams.append('sort', sort);
    queryParams.append('limit', String(limit));
    queryParams.append('page', String(page));

    const result = await req.get(
      `/balance-game/winning-items?${queryParams.toString()}`,
    );
    return result.data;
  };
}
